import React from "react";
import cmLogo from "../../../images/logo/catalogmaker2.png";
import "./CategoryHeader.scss";

const CategoryHeader = () => {
  return (
    <nav className="categoryNav">
      <div className="container flex flex-jcsb flex-aic">
        <div className="categoryNav-left">
          <img
            src={cmLogo}
            alt="create free product catalog"
            onClick={() => {
              window.location.href = "/";
            }}
          ></img>
        </div>
        <div className="categoryNav-right">
          <a href="/contact">Contact</a>
        </div>
      </div>
    </nav>
  );
};

export default CategoryHeader;
